import api from './api';

const projectCategoryMasterService = {
  getAllProjectCategoryMasters: async (params) => {
    try {
      const response = await api.get('/project-category-masters', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching project category masters:', error);
      throw error;
    }
  },

  getProjectCategoryMasterById: async (id) => {
    try {
      const response = await api.get(`/project-category-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching project category master with ID ${id}:`, error);
      throw error;
    }
  },

  createProjectCategoryMaster: async (categoryData) => {
    try {
      const response = await api.post('/project-category-masters', categoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating project category master:', error);
      throw error;
    }
  },

  updateProjectCategoryMaster: async (id, categoryData) => {
    try {
      const response = await api.put(`/project-category-masters/${id}`, categoryData);
      return response.data;
    } catch (error) {
      console.error(`Error updating project category master with ID ${id}:`, error);
      throw error;
    }
  },

  deleteProjectCategoryMaster: async (id) => {
    try {
      const response = await api.delete(`/project-category-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting project category master with ID ${id}:`, error);
      throw error;
    }
  },

  getProjectCategoryMasterStats: async () => {
    try {
      const response = await api.get('/project-category-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching project category master stats:', error);
      throw error;
    }
  },

  getParentCategories: async (excludeId = null) => {
    try {
      const params = excludeId ? { excludeId } : {};
      const response = await api.get('/project-category-masters/parent-categories', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching parent categories:', error);
      throw error;
    }
  }
};

export default projectCategoryMasterService;
